/**
 * Form gửi yêu cầu liên hệ về một BĐS.
 *
 * Logic submit nằm trong useContactRequestForm.
 * Hiển thị validation SĐT, thông báo thành công/lỗi, và nút gọi trực tiếp.
 */
import { useContactRequestForm } from '../../features/contacts/hooks/useContactRequestForm';
import { ButtonSpinner } from '../Common/ButtonSpinner';
import { ErrorMessage } from '../Common/ErrorMessage';
import { PhoneInput } from '../Common/PhoneInput';
import { TEXT } from '../../shared/languages';

/**
 * Form liên hệ khách hàng → seller/admin.
 * @param {Object} props
 * @param {string|number} props.propertyId - ID BĐS cần liên hệ
 */
export const ContactForm = ({ propertyId }) => {
  const {
    contactForm,
    successMessage,
    errorMessage,
    phoneError,
    isSubmittingContact,
    updateContactField,
    submitContactRequest,
  } = useContactRequestForm(propertyId);
  const t = TEXT.contact;
  const common = TEXT.common;

  const handleSubmit = async (event) => {
    event.preventDefault();
    await submitContactRequest();
  };

  return (
    <form className="contact-card" onSubmit={handleSubmit}>
      <h3>{t.formTitle}</h3>
      <p>{t.formDescription}</p>
      <ErrorMessage message={errorMessage} />
      {successMessage && <div className="success-box">{successMessage}</div>}
      <label>
        {t.fullName}
        <input
          required
          value={contactForm.name}
          onChange={(event) => updateContactField('name', event.target.value)}
          placeholder="Nguyễn Văn A"
        />
      </label>
      <label>
        {t.email}
        <input
          required
          type="email"
          value={contactForm.email}
          onChange={(event) => updateContactField('email', event.target.value)}
          placeholder="ban@email.com"
        />
      </label>
      <label>
        {t.phone}
        <PhoneInput
          required
          value={contactForm.phone}
          onChange={(value) => updateContactField('phone', value)}
        />
        {phoneError && <span className="field-hint field-hint--error">{phoneError}</span>}
      </label>
      <label>
        {t.message}
        <textarea
          required
          value={contactForm.message}
          onChange={(event) => updateContactField('message', event.target.value)}
          rows="4"
        />
      </label>
      <button className="button full-width" disabled={isSubmittingContact}>
        {isSubmittingContact && <ButtonSpinner />}
        {isSubmittingContact ? common.submitting : t.submit}
      </button>
      <a className="button call full-width" href="tel:0977545638">
        {t.callNow}
      </a>
    </form>
  );
};
